import * as types from './types'
import { processData, processRecords } from '@/store/utils'

const actions = {
  INIT ({ commit, firebase }) {},
  async [types.GET_LIST] ({ commit, firebase, claims }, state) {
    claims = await claims
    const currentCompany = claims.currentCompany

    let query = firebase.firestore()
                        .collection(`companies/${currentCompany}/recipients`)
    if (state) {
      query = query.where('state', '==', state)
    }

    query.onSnapshot(querySnapshot => {
      const records = processRecords(querySnapshot)

      commit('setList', records)
    })
  },
  async [types.GET] ({ commit, firebase, rootGetters }, id) {
    const currentCompany = rootGetters['global/currentCompanyId']

    firebase
      .firestore()
      .collection(`companies/${currentCompany}/recipients`)
      .doc(id)
      .onSnapshot(doc => {
        commit('set', processData(doc))
      })
  },
  async [types.GET_TIMELINE] ({ commit, firebase, rootGetters }, recipientId) {
    const currentCompany = rootGetters['global/currentCompanyId']

    firebase
      .firestore()
      .collection(`companies/${currentCompany}/recipients/${recipientId}/timelines`)
      .onSnapshot(querySnapshot => {
        const records = processRecords(querySnapshot)

        commit('setTimeline', records)
      })
  },
  [types.UNSET] ({ commit }) {
    commit('unset')
  }
}

export default actions
